import { Repository } from "./adapters/repository";

import * as retrieveSecondaryCriteriaTemplate from "./useCases/retrieveSecondaryCriteriaTemplate";
import * as editSecondaryCriteriaTemplate from "./useCases/editSecondaryCriteriaTemplate";

enum UseCases {
  retrieveSecondaryCriteriaTemplate = "retrieveSecondaryCriteriaTemplate",
  editSecondaryCriteriaTemplate = "editSecondaryCriteriaTemplate",
}

interface Core {
  [UseCases.retrieveSecondaryCriteriaTemplate]: retrieveSecondaryCriteriaTemplate.Interactor;
  [UseCases.editSecondaryCriteriaTemplate]: editSecondaryCriteriaTemplate.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveSecondaryCriteriaTemplate]:
      retrieveSecondaryCriteriaTemplate.createInteractor(
        dependencies.repository,
      ),
    [UseCases.editSecondaryCriteriaTemplate]:
      editSecondaryCriteriaTemplate.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
